class BasketItemsController {

  constructor(basket, prompt, basketItemService) {
    this.prompt = prompt;
    this.basketItemService = basketItemService;
    basket.promise && basket.promise.then(() => this.basket = basket);
  }

  price (guest) {
    return this.basketItemService.price(guest);
  }

  removeGuest (id) {
    this.basket.removeGuestFromBasket(id);
  }

  removeGuestItem (guest, index) {
    this.basket.removeItemFromGuest(guest, index);
  }

  typeDisplay (type) {
    if (type.indexOf('App\\') > -1) {
      type = type.slice(4);
    }

    if (type === 'SpaDay') {
      return 'Spa Day';
    }

    return type;
  }

  childPrice (item, index, child) {
    if (item.credit_state) {
      return item.credit_state[index];
    } else if (child) {
      let price;
      if (child.item_summary) {
        price = child.item_summary.price;
      } else {
        price = child.price;
      }
      price = parseFloat(price['price']);
      return price > 0 ? price : 0;
    }

    return 0;
  }

  displayTime (time) {
    let newTime = time.match(/\d{2}:\d{2}/);
    if (Array.isArray(newTime)) {
      return newTime[0];
    }

    return time;
  }

  hasItems () {
    return this.basket.contents.guest_details.length > 0
        && !!this.basket.contents.guest_details.find(guest => {
      return guest
        && guest.item_details
        && guest.item_details.length > 0;
    });
  }

  guestHasMultipleItems(guest) {
    return !!(guest.item_details.length > 1
      || guest.item_details.find(item => {
        return item.item_children
          && item.item_children.length > 0;
      }));
  }
}

BasketItemsController.$inject = [ 'basket', 'prompt', 'basketItemService' ];

export default BasketItemsController;



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/basket/controllers/basket.items.controller.js